import { ImgHTMLAttributes } from 'react';

interface Props extends ImgHTMLAttributes<any> {
  fallbackSrc?: string;
}

export function ImageWithFallback({
  fallbackSrc,
  src,
  ...props
}: Props) {
  return (
    <img
      src={src}
      alt={props.alt}
      onError={({ currentTarget }) => {
        currentTarget.onerror = null; // prevents looping
        currentTarget.src = fallbackSrc;
      }}
      {...props}
    />
  );
}
